import type { Branch } from '@/stores/auth-store'

const TERMINATED_BRANCH_STATUS_VALUES = new Set(['4', 'terminated', 'resigned', 'deleted'])

export const isSelectableBranchInstance = (branch: Pick<Branch, 'status' | 'isActive'>): boolean => {
  const normalizedStatus = String(branch.status ?? '').trim().toLowerCase()
  if (TERMINATED_BRANCH_STATUS_VALUES.has(normalizedStatus)) {
    return false
  }

  if (branch.isActive === false && normalizedStatus !== '' && normalizedStatus !== '0' && normalizedStatus !== 'pending') {
    return false
  }

  return true
}

export const filterSelectableBranchInstances = <T extends Pick<Branch, 'status' | 'isActive'>>(branches: T[]): T[] => (
  branches.filter(isSelectableBranchInstance)
)
